'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'messages';
var width = 640;
var height = 512;
var aliases = ["comments-alt"];
var unicode = 'f4b6';
var svgPathData = 'M416 63.1V256C416 291.3 387.3 319.9 352 319.9L224 320L115.1 381.6C112.9 383.3 110.4 384 108 384C101.8 384 96 379.1 96 372V320L64 320C28.75 320 0 291.3 0 256V63.1C0 28.75 28.75 0 64 0H352C387.3 0 416 28.75 416 63.1V63.1zM144 310.1L211.4 272H352C360.7 272 368 264.8 368 256V64C368 55.25 360.7 48 352 48H64C55.25 48 48 55.25 48 64V256C48 264.8 55.25 272 64 272H144V310.1zM256 384V352H304V384C304 392.7 311.2 400 320 400H428.6L496 438.1V400H576C584.7 400 592 392.7 592 384V192C592 183.3 584.7 176 576 176H448V128H576C611.3 128 640 156.7 640 191.1V384C640 419.3 611.3 448 576 448L544 448V500C544 507.1 538.2 512 532 512C529.6 512 527.1 511.3 524.9 509.6L416 448L320 447.9C284.8 447.9 256 419.3 256 384V384z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMessages = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;